module.exports = __webpack_public_path__ + "static/media/CompanyIntroduceImage02.e4f3b655.png";